import React from 'react'

import SelectProjectMulti from "../../../../app/quick-add/sections/view/components/forms/common-blocks/project-multi"
import {SystemStatus} from "../../../gd/const/system-status"
import FormManager from "../../../gd-form/common/form-manager"
import CustomView from "../../../model2/custom-view/custom-view"
import SelectTaskSystemStatus
    from "../../../../app/quick-add/sections/view/components/forms/common-blocks/task-system-status"
import Views_convertStatusStringToStatuses from "../../functions/convert-string-to-statuses"
import Views_convertStatusesToStatusString from "../../functions/convert-statuses-to-string"
import SelectUsersMulti from "../../../../app/quick-add/sections/view/components/forms/common-blocks/users-multi"
import quickAdd_getUsersIds from "../../../../app/quick-add/sections/view/components/forms/functions/get-users-ids"
import getAvailableProjectsByViewType from "../../functions/get-available-projects"
import {EntityType} from "../../../gd/const/item";

type WorkloadConditionsType = {
    projects            : ID[]
    assignedToUsers     : ID[]
    systemTaskStatuses  : SystemStatus[]
}

type Props = {
    className?  : string

    view        : CustomView
    disabled?   : boolean
    onChange    : { (conditions: WorkloadConditionsType):void }
}

// const debug = "ViewWorkload_Conditions"
const debug = false

export default function ViewWorkload_Conditions(props: Props) {

    debug && console.log(debug, 'render', props)

    const onUserChange = () => {
        debug && console.log(debug, 'onUserChange')

        const result = form.getValues()

        const conditions: WorkloadConditionsType = {
            projects            : result.projects,
            assignedToUsers     : result.assignedToUsers,
            systemTaskStatuses  : Views_convertStatusStringToStatuses(result.systemTaskStatuses)
        }

        debug && console.log(debug, 'onUserChange conditions', conditions)

        props.onChange(conditions)
    }

    const updateUsersField = (name: string, allUserIds: ID[]) => {
        const users = form.getValue(name);
        const newUsers = _.intersection(users, allUserIds)
        form.setFieldValue(name, newUsers)
    }

    const onParentSelect = (projects: ID[]) => {
        debug && console.log(debug, 'onParentSelect')

        form.onFormComponentValueChange('projects', projects)

        const newUsers = quickAdd_getUsersIds(projects)

        updateUsersField('assignedToUsers', newUsers)

        onUserChange()
    }

    const conditions = props.view.settings

    const initFormData: any = {
        projects            : conditions?.projects || [],
        assignedToUsers     : conditions?.assignedToUsers || [],
        systemTaskStatuses  : Views_convertStatusesToStatusString(conditions?.systemTaskStatuses),
    }

    const formStructure = {
        fields          : {
            projects            : { type: 'select',   isRequired: false,  label: 'Projects'},
            assignedToUsers     : { type: 'select',   isRequired: false,  label: 'Users',                   onUserChange: onUserChange},
            systemTaskStatuses  : { type: 'select',   isRequired: false,  label: 'System task statuses',    onUserChange: onUserChange},
        },
        isFormChanged   : true,
    }

    const form = new FormManager(formStructure, initFormData);
    const projectsIds = form.getValue('projects') || []
    const usersIds = quickAdd_getUsersIds(projectsIds)

    const additionalUsersOptions = [{
        id  : gd.const.timeline.NOT_ASSIGNED_ROW_ID, //backend should understand this id
        name: "Not assigned"
    }]

    const classes = Classes("ui5-form", props.className)

    return (
        <div className={classes}>
            <div className="tbl">
                <SelectProjectMulti form                = {form}
                                    formFieldName       = 'projects'
                                    availableProjects   = {getAvailableProjectsByViewType(props.view.type)}
                                    disabled            = {props.disabled}
                                    parentsFor          = {EntityType.PROJECT}
                                    onParentSelect      = {onParentSelect}/>

                <SelectUsersMulti label                     = "Assigned to users"
                                  form                      = {form}
                                  formFieldName             = 'assignedToUsers'
                                  usersIds                  = {usersIds}
                                  additionalUsersOptions    = {additionalUsersOptions}
                                  includeCurrentUser        = {true}
                                  disabled                  = {props.disabled}/>

                <SelectTaskSystemStatus form            = {form}
                                        formFieldName   = 'systemTaskStatuses'
                                        disabled        = {props.disabled}/>
            </div>
        </div>
    )
}
